import React from 'react';
import './style.css';



function Help() {
   

    return (
        <div className='commonPageDiv commingSoonTxt'>
           <h1>Comming Soon...</h1>
        </div>

    )
}

export default Help;